import { toState } from "../base/redux/functions";
export function getFlip(stateful) {
    return toState(stateful)['features/flip'];
}
